module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('div', {
    staticClass: "topline"
  }, [_c('div', {
    staticClass: "holder"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "bl-account"
    }
  }, [(_vm.props.authorizedUser != null) ? _c('span', {
    staticClass: "hello"
  }, [_vm._v("Здравствуйте, " + _vm._s(_vm.props.authorizedUser.formattedUserName))]) : _vm._e(), _vm._v(" "), (_vm.props.authorizedUser == null) ? _c('a', {
    staticClass: "enter",
    attrs: {
      "href": _vm.getEsiaUrl()
    }
  }, [_vm._v("Войти")]) : _c('a', {
    staticClass: "my",
    attrs: {
      "href": "/appeals"
    }
  }, [_vm._v("Мои обращения")]), _vm._v(" "), (_vm.props.authorizedUser != null) ? _c('a', {
    staticClass: "logout",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("Выйти")]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "holder"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('a', {
    staticClass: "btn-appeal btn",
    attrs: {
      "href": _vm.props.authorizedUser == null ? _vm.getEsiaUrl() : '/appeal'
    }
  }, [_c('span', [_vm._v("Подать обращение")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "bl-geo"
    }
  }, [_vm._v("\n                    Вы находитесь: "), _c('a', {
    staticClass: "curr",
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    attrs: {
      "id": "municipality_name_span"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "visual-version"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Слабовидящим")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "/",
      "id": "logo"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/logo.png"),
      "alt": "Государственная информационная система Омской области «Аппаратно-программный комплекс технических средств «Безопасный город»",
      "title": "Государственная информационная система Омской области «Аппаратно-программный комплекс технических средств «Безопасный город»"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Государственная информационная система Омской области «Аппаратно-программный комплекс технических средств «Безопасный город»")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "menu-holder"
    }
  }, [_c('nav', {
    attrs: {
      "id": "menu-main"
    }
  }, [_c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "/news"
    }
  }, [_vm._v("Новости")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/documents"
    }
  }, [_vm._v("Документы")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/contacts"
    }
  }, [_vm._v("Контакты ЕДДС МО")])])])]), _vm._v(" "), _c('div', {
    staticClass: "close"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "tel:112",
      "id": "tel"
    }
  }, [_c('span', [_vm._v("Телефон вызова экстренных оперативных служб:")]), _vm._v("112")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f8e0dbb","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VHeader.vue
// module id = 14
// module chunks = 1 2 3 4 5 6 7 8